const scrollers = document.querySelectorAll(".scroller");

function setMarqueeAnimation(scroller) {
  const scrollerInner = scroller.querySelector(".scroller__inner");
  if (!scrollerInner) return;

  // Remove previous duplicates
  Array.from(scrollerInner.children).forEach((el) => {
    if (el.getAttribute("aria-hidden") === "true") el.remove();
  });

  // Get original content
  const originalItems = Array.from(scrollerInner.children).filter(
    (el) => !el.hasAttribute("aria-hidden")
  );

  // Duplicate until at least 3x visible width for ultra-wide screens
  let contentWidth = scrollerInner.scrollWidth;
  const visibleWidth = scroller.offsetWidth;
  let dupCount = 0;
  while (contentWidth < visibleWidth * 3 && dupCount < 30) {
    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      scrollerInner.appendChild(clone);
    });
    contentWidth = scrollerInner.scrollWidth;
    dupCount++;
  }

  // Set animation duration based on content width (60px/sec as a base speed)
  const baseSpeed = 60; // px per second
  const duration = contentWidth / baseSpeed;
  scrollerInner.style.setProperty("--marquee-duration", `${duration}s`);
}

function setMarqueeOffsets() {
  document.querySelectorAll(".scroller").forEach((scroller) => {
    const scrollerInner = scroller.querySelector(".scroller__inner");
    if (!scrollerInner) return;
    const browserLeft = scroller.getBoundingClientRect().left;
    scrollerInner.style.setProperty(
      "--marquee-start-offset",
      `-${browserLeft - 48}px`
    ); // 48px ≈ 3rem
  });
}

function addAnimation() {
  scrollers.forEach((scroller) => {
    scroller.setAttribute("data-animated", true);
    setMarqueeAnimation(scroller);
  });
}

function multiplyContent() {
  document.querySelectorAll(".scroller__inner").forEach((inner) => {
    // Remove previous duplicates
    Array.from(inner.children).forEach((el) => {
      if (el.getAttribute("aria-hidden") === "true") el.remove();
    });
    const originals = Array.from(inner.children).filter(
      (el) => !el.hasAttribute("aria-hidden")
    );
    let contentWidth = inner.scrollWidth;
    const scroller = inner.closest(".scroller");
    const visibleWidth = scroller ? scroller.offsetWidth : window.innerWidth;
    let dupCount = 0;
    // Duplicate until at least 3x visible width for ultra-wide screens
    while (contentWidth < visibleWidth * 3 && dupCount < 30) {
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        inner.appendChild(clone);
      });
      contentWidth = inner.scrollWidth;
      dupCount++;
    }
  });
}

if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  addAnimation();
  window.addEventListener("resize", () => {
    setMarqueeOffsets();
    multiplyContent();
  });
  setMarqueeOffsets();
  multiplyContent();
}
